import React from "react";

const Newsletter = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 py-4 bg-white border-t">
      {/* Newsletter Section */}
      <div className="py-12 border-b">
        <div className="max-w-2xl mx-auto text-center">
          <h3 className="text-2xl font-semibold mb-4">Stay in the Loop</h3>
          <p className="text-gray-500 mb-6">
            Subscribe to our newsletter for exclusive deals, product launches,
            and inspiration.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
            <input
              type="email"
              placeholder="Enter your email"
              className="flex-1 px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <button className="px-4 bg-gradient-to-r from-[#82b016] to-green-600 hover:from-[#6fa010] hover:to-green-700 text-white py-2 rounded-lg shadow-lg transition-all duration-300 transform hover:-translate-y-0.5 hover:shadow-xl">
              Subscribe
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Newsletter;
